import { render, staticRenderFns } from "./IndexGroups.vue?vue&type=template&id=34b0cded&"
import script from "./IndexGroups.vue?vue&type=script&lang=js&"
export * from "./IndexGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports